import {
  Component,
  effect,
  inject,
  signal,
  untracked,
} from "@angular/core";
import { TranslocoModule } from "@jsverse/transloco";
import { DetailedUserService } from "../../services/user-profile/detailed-user-service";
import { ContactCardInterface } from "src/app/core/interfaces/contact-card-interface";
import { Loader } from "src/app/shared/components/loader/loader";
import { ContactCard } from "src/app/shared/components/contact-card/contact-card";
import { LanguageService } from "src/app/core/services/language-service";

@Component({
  selector: "app-hr-contact-page",
  imports: [TranslocoModule, Loader, ContactCard],
  templateUrl: "./hr-contact-page.html",
})
export class HrContactPage {
  detailedUserService = inject(DetailedUserService);
  private readonly languageService = inject(LanguageService);

  hrList = signal<ContactCardInterface[]>([]);
  loading = signal<boolean>(true);

  constructor() {
    effect(() => {
      this.languageService.currentLanguage();

      untracked(async () => {
        this.loading.set(true);
        try {
          const hrContacts = await this.detailedUserService.getContactRh();
          this.hrList.set(hrContacts);
        } finally {
          this.loading.set(false);
        }
      });
    });
  }

  getHrContactEntity(hrContact: ContactCardInterface): string {
    return hrContact.entity ?? "";
  }

  getHrContactBookingLink(hrContact: ContactCardInterface): string {
    return hrContact.bookingCalendarLink ?? "";
  }
}
